import { styled } from "@linaria/react"

import { Button } from "@/components/Button/Button.tsx"

export const StopButton = styled(Button)`
  width: 36px;
  height: 36px;

  background: var(--text-color);
  border-radius: var(--border-radius-round);

  &:hover:not(:disabled) {
    background: var(--text-color-80);
  }

  &:active:not(:disabled) {
    background: var(--text-color-90);
  }
`

export const StopIcon = styled.span`
  display: inline-block;
  height: 12px;
  width: 12px;

  background: var(--mask-color);
  border-radius: var(--border-radius-4);
`
